// extracted by mini-css-extract-plugin
module.exports = {"cell":"PayPage_cell__31q0t","lefttext":"PayPage_lefttext__3Blma","img":"PayPage_img__T4CtM"};